module.exports = __webpack_public_path__ + "img/logo.7f5f58d8.png";